import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { Guide } from 'src/app/shared/models/Guide';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { TovpilCookieService } from 'src/app/utils/tovpil-cookie.service';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { start } from 'repl';

@Component({
  selector: 'app-fii-journl',
  templateUrl: './fii-journl.component.html',
  styleUrls: ['./fii-journl.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class FiiJournlComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  responseFile?: ResponseFile;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[] = [];
  stringStores: any[];
  guides: Guide[];

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  // datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = true;
  buttonMessage: string[] = [];

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetLoadAmount = "getLoadAmount"
  endPointGetFiiMonths = "getFiiMonth";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";
  endPointGetStoreById = "getStoreById";
  endPointGetCreateUpdateDeleteFIIDtl = "getCreateUpdateDeleteFIIDtl";
  endPointGetGuideAndStoreName = "getGuideStoreAndLastname";
  endPointGetDependetLocalStores = "getDependetLocalStores";
  endPointGetFiiJournalSummary = "listFIIJournalSummary";

  endPointRetrieveCommentsByDate = "retrieveCommentsByDate";
  endPointCreateCommentsF = "createCommentsf";
  endPointGetApproveRejectJournalPer = "getApproveRejectJournalPer";

  /** DYNAMIC TABLES */
  dataFII: Record<string, any>[];
  colsFII: any[];
  rowsFII: number = 12;
  colsGlFII = ['concepId', 'descrip', 'amount', 'conType'];
  colsFiFII = [
    { name: 'ID', value: 'concepId' },
    { name: 'Descripción', value: 'descrip' },
    { name: 'Cantidad', value: 'amount' },
    { name: 'Tipo', value: 'conType' },
  ];

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private filesService: TovpilFilesService,
    private router: Router,
    private cookieService: TovpilCookieService,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private urlBuilderService: UrlBuilderService
  ) {
    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.conType = params.conType;
      this.dataParent.month = params.month;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.currentUser = currentUser;
    }

  }

  /**
    * The function initializes form groups for configuration and data, and updates the configuration form
    * with query parameters from the route.
    */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    console.debug("FiiJournl() Preferencuas de usuario: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: true }),
      selectedPeriod: new FormControl({ value: null, disabled: true }),
      selectedCurrency: new FormControl({ value: null }),
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedMonth: new FormControl({ value: null, disabled: true }),

      selectedComments: new FormControl({ value: "", disabled: false }),
    });
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.currentUser = currentUser;

    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn'n', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn'n', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      await this.getLanguages();
      await this.getMonth();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    console.debug("FiiJournl() Debug > Material Languages");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
    }
  }

  getMonth() {
    const month = this.dataParent.month - 1;
    if(this.dataParent?.month === '1'){
      this.globalUserDataForm.patchValue({
        'selectedMonth' : `${this.translations.lbl_semester} 1`
      });
    } else if (this.dataParent?.month === '2'){
      this.globalUserDataForm.patchValue({
        'selectedMonth' : `${this.translations.lbl_semester} 2`
      });
    } else if (this.dataParent?.month === '0'){
      this.globalUserDataForm.patchValue({
        'selectedMonth' : `${this.translations.lbl_year}`
      });
    } else{
      const monthName = this.capitalizeLastElement(new Intl.DateTimeFormat('es-MX', { month: 'long' }).format(new Date(2023, month, 1)));
    this.globalUserDataForm.patchValue({
      'selectedMonth' : monthName
    });
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods(language: string) {
    try {

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
    * This TypeScript function asynchronously fetches a list of currencies based on store ID and language
    * ID, handling errors and returning the data if successful.
    * @returns The function returns either the fetched currency data if
    * successful, or `null` if there are missing parameters, an error occurred during fetching, or an
    * exception was caught.
    */
  async getListCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        let lstCurrencies = result.data;
        let currencySelected = currency ? lstCurrencies.find(o => o.valueId === currency) ?? lstCurrencies[0] : lstCurrencies[0] ?? null;
        this.currencies = lstCurrencies;

        this.globalUserDataForm.patchValue({
          selectedCurrency: currencySelected
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string) {
    try {

      if (!storeId) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {

        this.globalUserDataForm.patchValue({
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
 * This TypeScript function asynchronously fetches dependent local stores data based on provided
 * parameters and handles any errors that may occur.
 * @param {string} month - The `month` parameter in the `getDependetLocalStores` function is a string
 * representing the month for which you want to fetch dependent local stores. It is a required
 * parameter for the function to work correctly.
 * @param {string} year - The `year` parameter in the `getDependetLocalStores` function is a string
 * representing the year for which you want to fetch dependent local stores. It is used to filter the
 * data based on the specified year.
 * @param {string} storeId - The `storeId` parameter is a unique identifier for a specific store. It is
 * used to fetch dependent local stores based on the provided `month` and `year` parameters.
 * @returns This function returns a boolean value - `true` if the dependent local stores data is
 * successfully fetched and stored in `this.stringStores`, and `false` if there are missing required
 * parameters, an error occurred during the fetch operation, or an exception is caught.
 */
  async getDependetLocalStores(month: string, year: string, storeId: string) {
    try {

      if (!storeId || !month || !year) {
        console.warn('Missing required parameters: storeId and period are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetDependetLocalStores, {
        storeId,
        year: year ?? null,
        period: month ?? null,
      });

      if (result.success) {
        let lstDependentStores = result.data;
        this.stringStores = lstDependentStores;
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('DEPENDENT LOCAL STORES Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {
      const language = this.globalUserPreferences?.preferences?.language || null;
      const storeId = this.globalUserPreferences?.storeId || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const period = this.globalUserPreferences?.preferences?.periodSelected || null;

      const validPeriodsResponse = await this.getValidPeriods(language);
      const validCurrencyResponse = await this.getListCurrencyByStoreId(coordinationStoreId, language, currency);
      const validCoordinationResponse = await this.getCoordination(coordinationStoreId);

      const validDependentResponse = await this.getDependetLocalStores(period?.year, period?.period, storeId);
      const validGetComments = await this.getCommentsF();

      if (validPeriodsResponse && validCurrencyResponse && validCoordinationResponse && validGetComments) {
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", validPeriodsResponse);
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {
    if (!this.globalUserDataForm.valid) {
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return;
    }
    try {
      this.blocked = true;

      const language = this.globalUserPreferences?.preferences?.language || null;
      const storeId = this.globalUserPreferences?.storeId || null;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const conType = this.dataParent.conType || null;
      const supStoreId = this.globalUserPreferences?.storeId || null;
      const period = this.globalUserPreferences?.preferences?.periodSelected || null;

      const amountResponse = await this.getListFII(storeId, language, conType);
      const buttonsResponse = await this.getApproveRejectJournalPer(supStoreId, coordinationStoreId, period?.year ?? null, period?.period ?? null);

      if (amountResponse) {
        console.debug("FiiJournl() 2.- Loading Data: ", amountResponse);

        this.blocked = false;
      } else {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * This TypeScript function asynchronously reloads a list amount and handles any errors that may occur.
   */
  async reloadGetListFII() {
    try {
      this.blocked = true;

      const language = this.globalUserPreferences?.preferences?.language || null;
      const storeId = this.globalUserPreferences?.storeId || null;
      const conType = this.dataParent.conType || null;

      const servsResponse = await this.getListFII(storeId, language, conType);

      if (servsResponse) {
        this.blocked = false;
      } else {
        //this.handleError('FII List', 'Hubo un problema al procesar los FII. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('FII List', 'Hubo un problema al procesar los FII. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  /**
   * The function `getListFII` is an asynchronous function that fetches data from an API endpoint and
   * handles the success and error cases.
   * @returns a Promise.
   */
  async getListFII(storeId: string, language: string, conType: string) {
    try {
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const period = this.globalUserPreferences?.preferences?.periodSelected || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const language = this.globalUserPreferences?.preferences?.language || null;
      let startValue;
      let endValue;

      if(this.dataParent?.month === '1'){
        startValue = '1';
        endValue = '6';
      } else if(this.dataParent?.month === '2'){
        startValue = '7';
        endValue = '12';
      } else if(this.dataParent?.month === '0'){
        startValue = '1';
        endValue = '12';
      } else{
        startValue = this.dataParent?.month;
        endValue = startValue;
      }

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetFiiJournalSummary, {
          "storeId": coordinationStoreId,
          "year": period?.year ?? null,
          "startValue": startValue ?? null,
          "endValue": endValue ?? null,
          "currCode": currency,
          "language": language
        }).then(result => {
          console.debug("FiiJournl() 3.- Debug List FII: ", result)
          if (result.success) {
            this.handleSuccessLstFII(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            //this.handleError('FII Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function "handleSuccessLstAmount" handles the success response of a data retrieval operation and
   * updates the necessary variables and properties accordingly.
   * @param {any[]} data - An array of objects containing the data to be processed.
   */
  async handleSuccessLstFII(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.colsFII = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFiFII);
      // Asignar los datos al arreglo de productos
      this.dataFII = data;
      // Asignar el número de filas por página dinámicamente
      this.rowsFII = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsFII);
    } else {
      this.dataFII = null;
      this.colsFII = null;
      //this.handleError('FII Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
 * The function `getCommentsF` is an asynchronous function that fetches data from an API endpoint and
 * handles the success and error cases.
 * @returns a Promise.
 */
  async getCommentsF() {
    try {
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const period = this.globalUserPreferences?.preferences?.periodSelected || null;

      const result = await this.tovpilCrudService.fetch(this.endPointRetrieveCommentsByDate, {
        "fileId": "FII",
        "key1Id": coordinationStoreId,
        "currDate": period?.year + '' + this.dataParent?.month + '01'
      });

      console.debug("FiiJournl() 3.- Debug List MONTH: ", result);

      if (result.success && result.data != null && result.data != undefined) {
        this.globalUserDataForm.patchValue({
          selectedComments: result?.data[0]?.comments ?? ""
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('FII MONTH', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * This TypeScript function asynchronously updates comments based on user preferences and retrieves
   * data from a specified endpoint.
   * @returns The `updateComments()` function returns a Promise.
   */
  async updateComments() {
    try {
      this.blocked = true;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const period = this.globalUserPreferences?.preferences?.periodSelected || null;
      const valueInsert = this.globalUserDataForm.get('selectedComments').value;

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointCreateCommentsF,
          {
            "id": {
              "fileId": "FII",
              "key1Id": coordinationStoreId,
              "currDate": period?.year + '' + this.dataParent?.month + '01'
            },
            "comments": valueInsert
          }).then(result => {
            console.debug("FiiJournl() 3.- Debug List MONTH: ", result)
            if (result.success) {
              this.blocked = false;
              this.globalUserDataForm.patchValue({
                selectedComments: result.data.comments ?? ""
              });
              resolve(true);
            } else {
              this.blocked = false;
              console.error("An error occurred while fetching purchase order data:");
              //this.handleError('FII MONTH', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
              resolve(false);
            }
          }).catch(error => {
            this.blocked = false;
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
      this.blocked = false;
      return false;
    }
  }

  /**
   * The function "capitalizeLastElement" takes a string as input and returns the same string with the
   * last element capitalized.
   * @param {string} str - The parameter `str` is a string that represents the input string.
   * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
   * with the `str` parameter.
   */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    return this.tovpilCrudService.getNestedValue(obj, field);
  }

  /**
   * The `exportExcel()` function exports data to an Excel file if the data is not null and not empty,
   * otherwise it displays an error message.
   */
  async exportExcel(_data: any[], _colsFilter: any[], _name: string) {
    this.blocked = true;
    try {
      await this.apiService.dwnFIIXls(
        {
          "storeId": this.globalUserPreferences?.preferences?.coordinationId || null,
          "year": this.globalUserPreferences?.preferences?.selYear || null,
          "currency": this.globalUserPreferences?.preferences?.selCurrency || null,
          "language": this.globalUserPreferences?.preferences?.language || null,
          "guideId": this.globalUserPreferences?.preferences?.guideId || null
        }
      ).then(
        data => {
          this.responseFile = data;

          const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;


          const link = document.createElement("a");
          link.href = source;
          //link.download = `${(this.item != null ? this.item.descri : "") + '_' + (this.itemsAlbum != null ? this.itemsAlbum.name : "") + '_' + itm.id.sequence + " " + itm.name + "." + this.item.sellUM}`
          link.download = this.responseFile.nameFile
          link.click();


        })
    } catch (error) {
      console.error("An error occurred while exporting excel:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}: ${error}` });
    } finally {
      this.blocked = false;
    }
  }

  /**
   * The function `exportPdf` generates a PDF file based on provided data and column filters.
   * @param {any[]} _data - The `_data` parameter is an array containing the data that will be used to
   * generate the PDF. It is expected to be an array of objects where each object represents a row of
   * data to be included in the PDF.
   * @param {any[]} _colsFilter - The `_colsFilter` parameter is an array containing objects with
   * properties `name` and `value`. It is used to filter and map the data in the `_data` array to
   * generate a PDF. Each object in `_colsFilter` specifies a column name and the corresponding value to
   * extract from the data
   * @param {string} _name - The `_name` parameter in the `exportPdf` function is a string that
   * represents the name of the PDF file that will be generated. It is used as a reference to name the
   * PDF file when it is exported.
   */
  exportPdf(_data: any[], _colsFilter: any[], _name: string) {
    if (_data === null || _data.length < 1) {
      //this.handleError('FII List', 'Hubo un problema al procesar la información del PDF. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } else {
      const filteredJSON = _data.map((item) => {
        const dynamicColumns = _colsFilter.map((col) => ({
          [col.name]: item ?
            this.tovpilCrudService.getNestedValueDynamic(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, _name);
    }
  }

  /**
   * The handleSuccess function logs "Success!" to the console and adds a success message using
   * messageService with the provided summary and detail.
   * @param {string} summary - Summary is a brief description or title that summarizes the outcome or
   * result of an operation. It is typically a short, concise statement that conveys the main message or
   * information. In the context of the `handleSuccess` function you provided, the `summary` parameter is
   * used to provide a summary message for
   * @param {string} detail - The `detail` parameter in the `handleSuccess` function is a string that
   * provides additional information or context related to the success message being displayed. It is
   * used to give more specific details about the successful operation that occurred.
   */
  private handleSuccess(summary: string, detail: string) {
    console.log("Success!");
    this.messageService.add({
      severity: 'success',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }

  /**
   * The handleError function handles errors by displaying a message and navigating back.
   * @param {string} summary - Summary is a brief description or title of the error that occurred. It
   * helps to provide a quick overview of what went wrong.
   * @param {string} detail - The `detail` parameter in the `handleError` function is a string that
   * provides additional information or details about the error that occurred. It is meant to give more
   * context or explanation about the error to help users understand what went wrong.
   */
  private handleError(summary: string, detail: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    console.debug("FiiJournl() onChangeUserPreferences")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    this.getLanguages();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataForm.get('selectedPeriod').value) || null;
    let currency = (this.globalUserDataForm.get('selectedCurrency').value)?.valueId || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      currency || null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  /**
   * The goBack function closes the current window.
   */
  async goBack() {
    try {

      let queryParams = {
        module: 'treasurer',
        view: 'fiiList'
      };

      let navigationExtras: NavigationExtras = {
        queryParams: queryParams
      };

      // Navegas a la ruta deseada con los parámetros de consulta
      this.router.navigate(['/treasurer/fiiList'], navigationExtras);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
      //this.handleError('Redirigir a CX4', 'Algo salió mal al redirigir a CX4');
    }
  }

  async approveSendToNational(transaction: string) {
    const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
    const period = this.globalUserPreferences?.preferences?.periodSelected || null;
    const supStoreId = this.globalUserPreferences?.storeId || null;
    const month = this.dataParent.month;
    try {
      this.confirmationService.confirm({
        message: '¿Estás seguro de que deseas enviar al nivel seleccionado?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sí',
        rejectLabel: 'No',
        accept: async() => {
          this.blocked = true;
          console.log('Se ha confirmado el envío al nacional');
          let result = await this.updatePreviousBalance(coordinationStoreId, supStoreId, transaction, period?.year ?? null, month ?? null);
          if (result) {
            this.handleSuccess("Envio Nacional", `Enviado correctamente`);
            this.goBack();
          } else {
            //this.handleError("Envio nacional", "No se pudo enviar a nacional");
          }

          this.blocked = false;
        },
        reject: () => {
          console.log('Se ha cancelado el envío al nacional');
          this.blocked = false;
        }
      });
    } catch (e) {
      console.error("fii-journal > sendToNational() > line 868 : ", e);
      this.blocked = false;
    }
  }

  async updatePreviousBalance(_storeId: string, _supStoreId: string, _transaction: string, _year: string, _month: string) {
    try {
      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetApproveRejectJournalPer,
          {
            "storeId": _storeId,
            "year": _year,
            "month": _month,
            "supStoreId": _supStoreId,
            "transaction": _transaction
          }).then(result => {
            console.debug("4.- Debug List updatePreviousBalance: ", result)
            if (result.success && result.data != undefined && result.data != null) {
              resolve(true);
            } else {
              console.error("An error occurred while fetching purchase order data:");
              resolve(false);
            }
          }).catch(error => {
            console.error(error);
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function isNumeric checks if a value is a numeric type in TypeScript.
   * @param {any} value - The `value` parameter in the `isNumeric` function is of type `any`, which means
   * it can be any data type in TypeScript. The function checks if the value is numeric by ensuring that
   * it is not `NaN`, is finite, and is not a string.
   * @returns The function `isNumeric` returns a boolean value indicating whether the input `value` is a
   * numeric value or not.
   */
  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value) && typeof value !== 'string';
  }

  /**
   * The function `getApproveRejectJournalPer` fetches data for approving or rejecting journal entries
   * based on store ID, year, and month.
   * @param {string} _supStoreId - The `_supStoreId` parameter is used to specify the security store ID
   * for the operation. It is a string type parameter that is passed to the `getApproveRejectJournalPer`
   * function to fetch data related to approving or rejecting journal entries for a specific store, year,
   * and month.
   * @param {string} _storeId - The `_storeId` parameter is the ID of the store selected from the tree.
   * @param {string} _year - The `_year` parameter in the `getApproveRejectJournalPer` function is used
   * to specify the year for which you want to retrieve data. It is a string parameter that represents
   * the year in a specific format (e.g., "2022", "2023", etc.).
   * @param {string} _month - The `_month` parameter in the `getApproveRejectJournalPer` function
   * represents the month for which you want to retrieve data. It is a string parameter that should
   * contain the month value in a specific format (e.g., "01" for January, "02" for February, and so
   * @returns This function is returning a Promise. The Promise will resolve with a boolean value (true
   * or false) based on the success of fetching data from the `tovpilCrudService`. If the data is
   * successfully fetched and certain conditions are met, it will resolve with `true`. If there is an
   * error during the fetch operation, it will resolve with `false`. If there is an error in the
   */
  async getApproveRejectJournalPer(_supStoreId: string, _storeId: string, _year: string, _month: string) {
    try {
      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetApproveRejectJournalPer,
          {
            "storeId": _storeId, // store selected del Arbol
            "year": _year, //año
            "month": this.dataParent?.month ?? null, // mes
            "transaction": "GET", // GET es obtener botones a mostrar, REJECT=Devolver,  APPROVE = Aprobar
            "supStoreId": _supStoreId // security.storeId
          }

        ).then(result => {
          console.debug("4.- Debug List getApproveRejectJournalPer: ", result)
          if (result.success && result.data != undefined && result.data != null && result.data?.status === 'OK') {
            this.buttonMessage = result?.data?.errorMessage ?? null;
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data getApproveRejectJournalPer: ");
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function redirectToConceptDetail() is defined in TypeScript.
   */
  redirectToConceptDetail(transaction: any) {
    try {

      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const period = this.globalUserPreferences?.preferences?.periodSelected || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const language = this.globalUserPreferences?.preferences?.language || null;

      // HERE UPDATE COOKIES
      const queryParams = {
        storeId: coordinationStoreId ?? null,
        month: this.dataParent.month ?? null,
        year: period.year ?? null,
        incExpId: transaction['concepId'] ?? null,
        currCode: currency,
        language: language,
      };

      try {
        const url = this.urlBuilderService.buildUrl('/treasurer/fiiJournlConceptDetail', queryParams);
        this.router.navigateByUrl(url);

      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        //this.handleError('Redirigir a CX4', 'Algo salio mal al redirigir a CX4');
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      //this.handleError('Redirigir a CX4', 'Algo salio mal al redirigir a CX4');
    }
  }

  getApproveButtonLabel() {
    if (this.buttonMessage?.includes('approve_') && this.buttonMessage?.includes('local_'))
      return `${this.translations.lbl_send} ${this.translations.lbl_to} ${this.translations.lbl_national}`
    if (this.buttonMessage?.includes('approve_') && this.buttonMessage?.includes('natio_'))
      return `${this.translations.lbl_send} ${this.translations.lbl_to} ${this.translations.lbl_zonal}`
    if (this.buttonMessage?.includes('approve_') && this.buttonMessage?.includes('zonal_'))
      return `${this.translations.lbl_approve} (Internacional)`
  }
}
